import React from 'react';
import { isSafari } from 'react-device-detect';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import './style.scss';
import PDFImageRenderViewer from './index_image_render';
import PDFCanvasRenderViewer from './index_canvas_render';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js?t=${Date.now()}`;

interface StateProps {
  file: string | undefined | null;
  isBottom?: () => void;
  scale?: number;
}

//pdf埋め込み
const PDFViewer: React.FC<StateProps> = (props: StateProps) => {
  if (isSafari) {
    return PDFImageRenderViewer(props);
  } else {
    return PDFCanvasRenderViewer(props);
  }
};
export default PDFViewer;
